// HtmlEmojis.jsx
import React from "react";

const HtmlEmojis = () => {
  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif", lineHeight: "1.6" }}>
      <h1>HTML Emojis - Comprehensive Notes</h1>

      {/* Introduction */}
      <section id="introduction">
        <h2>1. Introduction to HTML Emojis</h2>
        <p>
          Emojis are pictorial symbols used to express emotions, objects, or concepts.
          In HTML, emojis can be added using <strong>Unicode numeric codes</strong> or directly using characters.
          Ensure your document uses <code>UTF-8</code> encoding.
        </p>
      </section>

      {/* Basic Emojis */}
      <section id="basic-emojis">
        <h2>2. Basic Emojis</h2>
        <ul>
          <li>Smiley: &#x1F600; (😀)</li>
          <li>Grinning Face: &#x1F601; (😁)</li>
          <li>Winking Face: &#x1F609; (😉)</li>
          <li>Sad Face: &#x1F622; (😢)</li>
          <li>Crying Face: &#x1F62D; (😭)</li>
        </ul>
      </section>

      {/* Hand Gestures */}
      <section id="hand-gestures">
        <h2>3. Hand Gestures</h2>
        <ul>
          <li>Thumbs Up: &#x1F44D; (👍)</li>
          <li>Thumbs Down: &#x1F44E; (👎)</li>
          <li>Clapping Hands: &#x1F44F; (👏)</li>
          <li>Raised Hand: &#x1F64B; (🙋)</li>
          <li>Victory Sign: &#x270C; (✌️)</li>
        </ul>
      </section>

      {/* Objects & Symbols */}
      <section id="objects-symbols">
        <h2>4. Objects & Symbols</h2>
        <ul>
          <li>Heart: &#x2764; (❤️)</li>
          <li>Star: &#x2B50; (⭐)</li>
          <li>Fire: &#x1F525; (🔥)</li>
          <li>Money Bag: &#x1F4B0; (💰)</li>
          <li>Phone: &#x1F4DE; (📞)</li>
        </ul>
      </section>

      {/* Animals & Nature */}
      <section id="animals-nature">
        <h2>5. Animals & Nature</h2>
        <ul>
          <li>Dog Face: &#x1F436; (🐶)</li>
          <li>Cat Face: &#x1F431; (🐱)</li>
          <li>Monkey Face: &#x1F435; (🐵)</li>
          <li>Sun: &#x2600; (☀️)</li>
          <li>Rainbow: &#x1F308; (🌈)</li>
        </ul>
      </section>

      {/* Food & Drink */}
      <section id="food-drink">
        <h2>6. Food & Drink</h2>
        <ul>
          <li>Pizza: &#x1F355; (🍕)</li>
          <li>Burger: &#x1F354; (🍔)</li>
          <li>Ice Cream: &#x1F368; (🍨)</li>
          <li>Coffee: &#x2615; (☕)</li>
          <li>Beer: &#x1F37A; (🍺)</li>
        </ul>
      </section>

      {/* Travel & Places */}
      <section id="travel-places">
        <h2>7. Travel & Places</h2>
        <ul>
          <li>Airplane: &#x2708; (✈️)</li>
          <li>Car: &#x1F697; (🚗)</li>
          <li>Boat: &#x26F5; (⛵)</li>
          <li>Globe: &#x1F30E; (🌎)</li>
          <li>Mountain: &#x26F0; (⛰️)</li>
        </ul>
      </section>

      {/* Best Practices */}
      <section id="best-practices">
        <h2>8. Best Practices</h2>
        <ul>
          <li>Always use <code>UTF-8</code> encoding for proper emoji rendering.</li>
          <li>Prefer Unicode numeric codes (e.g., &#x1F600;) for consistency.</li>
          <li>Do not use emojis as a substitute for semantic content.</li>
          <li>Test emojis across browsers and platforms for compatibility.</li>
        </ul>
      </section>
    </div>
  );
};

export default HtmlEmojis;
